import ability from '@/libs/acl/ability'

export default function permission() {
  const canUpdate = quoteAgreement => ability.can('update', 'QuoteAgreement') && quoteAgreement.status === 100

  const canCreate = () => ability.can('create', 'QuoteAgreement')

  const canDelete = () => ability.can('delete', 'QuoteAgreement')

  return {
    canUpdate,
    canCreate,
    canDelete,
  }
}
